<template>
    <v-col cols="12" sm="6" md="4" lg="3" xl="3">
        <v-card>
            <v-toolbar flat dense color="grey lighten-4">
                <v-toolbar-title>
                    {{ widget.body.title }}
                </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="sortedOrders"
                    :loading="newOrdersLoading"
                    :items-per-page="10"
                    dense
                    :mobile-breakpoint="0"
                    height="300"
                >
                    <template #item="{item}">
                        <tr>
                            <td>
                                {{ item.name }}
                            </td>
                            <td>
                                {{ formatNumber(item.count) }}
                            </td>
                            <td>
                                {{ formatNumber(item.sum) }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>

import tooltipDelay from '@/mixins/tooltip'
import pagination from '@/mixins/dataTablePagination'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'NewOrders',
    mixins: [
        tooltipDelay,
        pagination
    ],
    props: {
        widget: {
            type: Object,
            default: null
        },
        permissions: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Produkt',
                    value: 'name',
                    sortable: false,
                },
                {
                    text: 'Ilość zamówień',
                    value: 'count',
                    sortable: false,
                    align: 'left'
                },
                {
                    text: 'Nakład',
                    value: 'sum',
                    sortable: false,
                    align: 'left'
                },
            ],
        }
    },
    computed: {
        sortedOrders() {
            return this.sortOrdersAmount()
        },
        newOrders() {
            return this.$store.state.dashboard.dashboard.newOrders
        },
        newOrdersLoading() {
            return this.$store.state.dashboard.dashboard.newOrdersLoading
        },
    },
    created() {
        this.getDashboard()
    },
    methods: {
        formatNumber(number) {
            return new Intl.NumberFormat('pl-PL').format(number)
        },
        sortOrdersAmount() {
            return this.newOrders.sort((a, b) => b.count - a.count)
        },
        getDashboard() {
            this.$store.dispatch('dashboard/getDashboardItem', {
                item: this.widget,
                paginate: '',
                query: '?dataFromStatusLogService=true'
            })
                .catch(error => {
                    errorHandler(error)
                })
        }
    }
}
</script>